import React from "react";
import PropTypes from "prop-types";

import "./section.scss";

import PageList from "../PageList/pageList";
import { TEMPLATES } from "../../utils/constants";

const Section = ({
  sectionPages = [],
  allPagesData = {},
}) => {
  return (
    <div className="section">
      {sectionPages?.map(uri => {
        const {
          title = "",
          "child-pages": childPages = [],
          templateName = "",
        } = allPagesData[uri] || {};

        if (templateName === TEMPLATES.FAQ) {
          return (
            <PageList
              heading=""
              allPagesData={allPagesData}
              showIcon={false}
              pages={[uri]}
              key={uri}
            />
          );
        }
        return (
          <PageList
            heading={title}
            allPagesData={allPagesData}
            showIcon={false}
            pages={childPages}
            key={uri}
          />
        );
      })}
    </div>
  );
};

Section.propTypes = {
  sectionPages: PropTypes.array,
  allPagesData: PropTypes.object,
};

export default Section;
